import { Grid, Stack } from "@mui/material";
import { MprcButton } from "components";
import { ButtonClose } from "components/buttons";
import { AssessmentMode, AssessmentPlayerMode, EvolutionPermissions, SurveyReviewBehaviorBeforeExpire } from "generated/CoreApi_v1";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { DashboardPaths } from "routes/DashboardRouter";
import { useInstanceContext } from "views/assessment/player/AssPlayerBase";

/////////////////////////////////////////////////////////////////////////////////

interface IProps {
    preview: boolean;
    goBackQuestion: () => void;
    onClose: () => void;
    onReview: () => void;
}

export const AssPlayerConclusionActions: React.FC<IProps> = (props) => {

    const { challengeRev, viewData, createNewInstance } = useInstanceContext();

    const { preview, onClose, onReview, goBackQuestion } = props;
    const { t } = useTranslation("assessment");
    const navigate = useNavigate();

    ///
    const RenderActionEvaluation = () => {
        return (
            <>
                {
                    preview &&
                    <MprcButton
                        variant="contained"
                        color="warning"
                        text={t("AssPlayer.Conclusion.RevisionButtonText")}
                        title={t("AssPlayer.Conclusion.RevisionButtonTitle")}
                        onClick={onReview}
                    />
                }
                <ButtonClose
                    color="primary"
                    variant="contained"
                    sx={{ marginRight: 2 }}
                    onClick={onClose}
                />
            </>
        );
    };

    ///
    const RenderActionSurvey = () => {
        return (
            <>
                {
                    preview || viewData?.surv?.beforeExpireBehavior == SurveyReviewBehaviorBeforeExpire.ReviewResults
                        ?
                        <MprcButton
                            variant="contained"
                            color="warning"
                            text={t("AssPlayer.Conclusion.PartialResultsButtonText")}
                            title={t("AssPlayer.Conclusion.PartialResultsButtonTitle")}
                            onClick={onReview}
                        />
                        : viewData?.playerMode == AssessmentPlayerMode.UserReview || viewData?.playerMode == AssessmentPlayerMode.FinalResult
                            ?
                            <MprcButton
                                variant="contained"
                                color="muted"
                                text={t("AssPlayer.Question.BackButtonText")}
                                title={t("AssPlayer.Question.BackButtonTitle")}
                                onClick={() => goBackQuestion()}
                            />
                            :
                            null
                }
                <ButtonClose
                    color="primary"
                    variant="contained"
                    sx={{ marginRight: 2 }}
                    onClick={onClose}
                />

            </>
        );
    };

    const RenderActionChallenge = () => {

        if (challengeRev == null) return;

        return (
            <Grid container m={1} width={"100%"}>
                <Grid size="grow">
                    {
                        challengeRev.knowledgeTestsLeft > 0 &&
                        <MprcButton
                            variant="contained"
                            color="warning"
                            text={t("AssPlayer.Conclusion.Challenge.NewChallengeButtonText")}
                            title={t("AssPlayer.Conclusion.Challenge.NewChallengeButtonTitle")}
                            onClick={() => createNewInstance()}
                        />
                    }
                </Grid>
                <Grid>
                    <Stack direction="row" spacing={2}>
                        <MprcButton
                            variant="contained"
                            color="primary"
                            text={t("AssPlayer.Conclusion.Challenge.YourEvolutionButtonText")}
                            title={t("AssPlayer.Conclusion.Challenge.YourEvolutionButtonTitle")}
                            onClick={() => navigate(DashboardPaths.UserEvolution, { state: { tab: EvolutionPermissions.Challenge } })}
                        />
                        <ButtonClose
                            color="primary"
                            variant="contained"
                            sx={{ marginRight: 2 }}
                            onClick={onClose}
                        />
                    </Stack>
                </Grid>
            </Grid>
        );
    };

    return (
        <>
            {
                viewData?.mode == AssessmentMode.Evaluation
                    ? RenderActionEvaluation()
                    : viewData?.mode == AssessmentMode.Survey
                        ? RenderActionSurvey()
                        : RenderActionChallenge()
            }
        </>
    );
};
